import { parseEnum } from './parseEnum'

/** Validates that a nullable string is a member of the given API enum, preserving null. */
export function parseNullableEnum<TEnum extends Record<string, string>>(
  value: string | null,
  enumObject: TEnum,
  enumName: string
): TEnum[keyof TEnum] | null {
  if (value === null) return null
  return parseEnum(value, enumObject, enumName)
}
